"use client";

import { useState } from "react";
import { X } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Dialog, DialogContent, DialogOverlay, DialogPortal } from "@/components/ui/dialog";
export default function Gallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<number | null>(null);
  const images = [{
    src: "https://mishmashinterpred.com/wp-content/uploads/2026/02/Screenshot_20260221-114733_Снимки.webp?v=x9p5jgu2uno",
    caption: ""
  }, {
    src: "https://mishmashinterpred.com/wp-content/uploads/2026/02/Screenshot_20260221-115053_Снимки.webp?v=9qqe1pejkmj",
    caption: ""
  }, {
    src: "https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-3e5706a74f51e3cf966459603949ce72-V.webp?v=w25ekguzz7d",
    caption: ""
  }, {
    src: "https://mishmashinterpred.com/wp-content/uploads/2026/03/Screenshot_20260225-120224_Facebook1.webp?v=xwdk7kkkvk8",
    caption: ""
  }, {
    src: "https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-048d6fc8726e50a604d3805236f36d99-V.webp?v=3q6b1yy0ahx",
    caption: ""
  }, {
    src: "https://mishmashinterpred.com/wp-content/uploads/2026/02/Screenshot_20260221-115011_Снимки.webp?v=an83la7p86f",
    caption: ""
  }, {
    src: "https://mishmashinterpred.com/wp-content/uploads/2026/02/Screenshot_20260221-114900_Снимки.webp?v=mwtb6muojqj",
    caption: ""
  }, {
    src: "https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-fc99adaa8f7e3ccab639ea641fc59ff4-V.webp?v=6czc82ssfqd",
    caption: ""
  }, {
    src: "https://mishmashinterpred.com/wp-content/uploads/2026/03/Screenshot_20260225-120247_Facebook1.webp?v=gs76hjj59aj",
    caption: ""
  }, {
    src: "https://mishmashinterpred.com/wp-content/uploads/2026/03/Screenshot_20260225-120155_Facebook1.webp?v=mt9ac71van",
    caption: ""
  }, {
    src: "https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/Messenger_creation_CF96B7C8-D419-46E4-8656-1FF9E26AC22F.webp?v=tgho2g2swkf",
    caption: "Телешки език пане с пържени картофи"
  }, {
    src: "https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-d20776159488780bf121e28e31704065-V.webp?v=w1xpb74jjvq",
    caption: ""
  }, {
    src: "https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-91fc20efaab3289aa9c45c2745b7bbca-V.webp?v=h6ju3bpituq",
    caption: "Частно събитие"
  }];
  const openLightbox = (index: number) => {
    setSelectedImage(index);
    setLightboxOpen(true);
  };
  const closeLightbox = () => {
    setLightboxOpen(false);
    setSelectedImage(null);
  };
  const nextImage = () => {
    if (selectedImage !== null) {
      setSelectedImage((selectedImage + 1) % images.length);
    }
  };
  const prevImage = () => {
    if (selectedImage !== null) {
      setSelectedImage((selectedImage - 1 + images.length) % images.length);
    }
  };
  return <section id="галерия" className="relative py-20 bg-dark-background text-dark-foreground overflow-hidden">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-white font-display font-bold text-[32px] leading-[1.25] tracking-tight mb-4">
            Галерия
          </h2>
          <p className="text-white/80 text-[16px] leading-[1.5] max-w-2xl mx-auto">Разгледайте примери за наши дневни специалитети и проведени събития</p>
        </div>

        <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:auto-rows-[200px]">
          {images.map((image, i) => {
          const spanClass = i === 0 || i === 5 ? "lg:row-span-2" : i === 3 || i === 6 ? "lg:col-span-2" : "";
          return <div key={i} data-index={i} className={`group relative overflow-hidden rounded-lg shadow-soft cursor-pointer transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:shadow-medium hover:scale-[1.03] ${spanClass} ${isVisible ? "animate-reveal opacity-100" : "opacity-0"}`} style={{
            animationDelay: `${i * 60}ms`
          }} onClick={() => openLightbox(i)}>
                <img src={image.src} alt={image.caption} className="w-full h-full object-contain sm:object-cover transition-all duration-[var(--duration-medium)] group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)] flex items-end p-4">
                  <p className="text-white text-sm font-semibold drop-shadow-lg">
                    {image.caption}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>

      <Dialog open={lightboxOpen} onOpenChange={setLightboxOpen}>
        <DialogPortal>
          <DialogOverlay className="bg-black/90" />
          <DialogContent showCloseButton={false} className="max-w-[95vw] max-h-[95vh] w-auto h-auto p-0 border-0 bg-transparent shadow-none flex items-center justify-center">
            {selectedImage !== null && <div className="relative flex items-center justify-center w-full h-full">
                <button onClick={closeLightbox} className="absolute top-4 right-4 z-50 text-white/80 hover:text-white transition-colors duration-[var(--duration-fast)] focus:outline-none" aria-label="Затвори">
                  <X className="w-8 h-8" />
                </button>

                <button onClick={prevImage} className="absolute left-4 top-1/2 -translate-y-1/2 z-40 text-white/80 hover:text-white text-4xl font-bold transition-colors duration-[var(--duration-fast)] focus:outline-none" aria-label="Предишна снимка">
                  ‹
                </button>

                <img src={images[selectedImage].src} alt={images[selectedImage].caption} className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-clay-hover transition-all duration-[var(--duration-medium)]" />

                <button onClick={nextImage} className="absolute right-4 top-1/2 -translate-y-1/2 z-40 text-white/80 hover:text-white text-4xl font-bold transition-colors duration-[var(--duration-fast)] focus:outline-none" aria-label="Следваща снимка">
                  ›
                </button>

                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/60 backdrop-blur-sm px-6 py-3 rounded-full">
                  <p className="text-white text-sm font-semibold">
                    {images[selectedImage].caption}
                  </p>
                </div>
              </div>}
          </DialogContent>
        </DialogPortal>
      </Dialog>
    </section>;
}